import alt from 'components/Dispatcher';
import {Record} from 'immutable';

class VotingRadioButtonsSearchFieldActions {
  constructor() {
    this.generateActions(
      'fetchDepartments',
      'fetchDepartmentsSuccess',
      'fetchDepartmentsError',

      'fetchTeams',
      'fetchTeamsSuccess',
      'fetchTeamsError',

      'changeVoting',
      'changeVotingLevel',
      'removeVotingValue',
      'resetVoting',
      'removeCurrentVotingValue'
    );
  }
}

export const VotingRadioButtonsSearchFieldValue = Record(
  {key: null, value: null},
  'VotingRadioButtonsSearchFieldValue'
);
export default alt.createActions(VotingRadioButtonsSearchFieldActions);
